@if (zoneSg()) {
  @let submissionError =
    zonesEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-centered-overlay>
    <atn-ds-widget [title]="titleSg()">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancelClickHandler()"
      ></i>
      <div class="atn-admin-zone__content">
        <atn-ds-text
          label="Name"
          placeholder="Enter a name"
          [value]="nameSg()"
          (change)="updateZonePropertyHandler('name', $event ?? '')"
          data-test-id="name-label"
        ></atn-ds-text>
        <atn-ds-text
          label="Alias"
          placeholder="Enter an alias"
          [value]="aliasSg()"
          (change)="updateZonePropertyHandler('alias', $event ?? '')"
          data-test-id="alias-label"
        ></atn-ds-text>
        <atn-ds-text
          label="Code"
          placeholder="Enter a code"
          [value]="codeSg()"
          (change)="updateZonePropertyHandler('code', $event ?? '')"
          data-test-id="code-label"
        ></atn-ds-text>
        <atn-ds-text
          label="Description"
          placeholder="Enter description"
          [value]="descriptionSg()"
          (change)="updateZonePropertyHandler('description', $event ?? '')"
          data-test-id="description-label"
        ></atn-ds-text>
        <atn-admin-error-message [message]="submissionError" />
      </div>
      <div
        class="atn-admin-zone__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button (click)="saveClickHandler()"> Save </atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
